import React, { useState } from "react";
import styled from "styled-components";
import aaron_pic from "../assets/blobs/aaron_pic.png";
import outline_pic from "../assets/blobs/outline.png";
import popup_mag from "../assets/blobs/popup_mag.png";
import up_state from "../assets/blobs/up_state.png";
import theater_pic from "../assets/blobs/theater.png";
import macdowell from "../assets/blobs/macdowell.png";
import tribeca_logo from "../assets/blobs/tribeca_logo.png";
import { useIsMobile } from "./helpers";
import Navbar from "./Navbar";

function Header() {
  const [isTextCopied, setIsTextCopied] = useState("Copy");
  const [showCopyText, setShowCopyText] = useState(false);
  const isMobile = useIsMobile();

  const copyToClipboard = (e) => {
    const el = document.createElement("textarea");
    el.value = "edwards.aaron12@gmail.com";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    if (isMobile) {
      setIsTextCopied("Copied :)");
      setShowCopyText(true);
      setTimeout(() => {
        setShowCopyText(false);
        setIsTextCopied("Copy");
      }, 1500);
    } else {
      setIsTextCopied("Copied :)");

      if (!showCopyText) {
        setTimeout(() => {
          setIsTextCopied("Copy");
        }, 2000);
      }
    }
  };

  const showCopyTextFunc = () => {
    if (!isMobile) {
      setShowCopyText(true);
    }
  };

  const hideCopyTextFunc = () => {
    if (!isMobile) {
      setShowCopyText(false);
      setIsTextCopied("Copy");
    }
  };

  const renderEmailButton = () => {
    return (
      <EmailTextWrapper>
        at{" "}
        <EmailText
          onClick={copyToClipboard}
          onMouseEnter={() => showCopyTextFunc()}
          onMouseLeave={() => hideCopyTextFunc()}
        >
          {
            <CopyWrapper>
              <CopyText
                style={{
                  visibility: showCopyText ? "visible" : "hidden",
                }}
              >
                {isTextCopied}
              </CopyText>
            </CopyWrapper>
          }
          edwards.aaron12@gmail.com
        </EmailText>
      </EmailTextWrapper>
    );
  };

  const renderBlob = (outline_pic) => {
    return (
      <ImageSpan>
        <ImageWrapper src={outline_pic} />
      </ImageSpan>
    );
  };

  const renderLink = (link, text, sameTab = false) => {
    return (
      <LinkWrapper href={link} target={sameTab ? "_self" : "_blank"}>
        {text}
      </LinkWrapper>
    );
  };

  return (
    <HeaderWrapper>
      <Navbar />
      <HeaderContent>
        Hey! I'm{" "}
        {renderLink(
          "https://www.instagram.com/aaronmedwards/",
          "Aaron Edwards"
        )}{" "}
        {renderBlob(aaron_pic)}. I'm an interdisciplinary director, story editor and writer working across text, stage and narrative audio {renderBlob(theater_pic)}.
        I love helping people tell stories from the heart, making theater that melds sound with physical space and guiding deeply reported journalism.
        My work has appeared in places like BAM, Lincoln Center {renderBlob(popup_mag)}, UnionDocs, The Brooklyn Public Library and the Tribeca Festival {renderBlob(tribeca_logo)}.
        I've been named a Media honoree in{" "}
        {renderLink(
          "https://www.forbes.com/profile/aaron-edwards/?sh=230a901173a1",
          "Forbes"
        )}{" "}
        and awarded a{" "}
        {renderLink(
          "https://www.macdowell.org/artists/aaron-edwards",
          "MacDowell Fellowship"
        )}{" "}
        {renderBlob(macdowell)}. I'm from Jamaica, Queens (shoutout to P.S. 52),
        my family is from Jamaica, the island (shoutout to Accompong) and I live
        in the Hudson Valley (shoutout to trees) {renderBlob(up_state)}. Some of
        my projects are below, and {renderLink("/morework", "here", true)}. Say hi{" "}
        {renderEmailButton()}.
      </HeaderContent>
    </HeaderWrapper>
  );
}

export default Header;

/* Header Styles */

const HeaderWrapper = styled.div`
  margin: 0px 50px;
  margin-top: 40px;
  z-index: 5;
  max-width: 1600px;
  gap: 50px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    margin: 0px 20px;
    margin-top: 30px;
    gap: 30px;
  }
`;

const HeaderContent = styled.div`
  font-size: 32px;
  letter-spacing: 1px;
  line-height: 40px;

  @media only screen and (max-width: 600px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

/* Header Image Styles */

const ImageSpan = styled.span`
  vertical-align: middle;
  margin: 0 2px;
  line-height: 35px;

  @media only screen and (max-width: 600px) {
    line-height: 22px;
  }
`;

const ImageWrapper = styled.img`
  height: 35px;

  @media only screen and (max-width: 600px) {
    height: 22px;
  }
`;

/* Email Button Styles */

const EmailText = styled.span`
  display: inline-block;
  border-bottom: 1px solid black;
  cursor: pointer;

  :hover {
    color: #e97522;
    border-color: #e97522;
  }

  @media only screen and (max-width: 600px) {
    :hover {
      color: black;
      border-color: black;
    }
  }
`;

const EmailTextWrapper = styled.span``;

const CopyWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 5px;

  a {
    text-decoration: none;
  }
`;

const CopyText = styled.div`
  visibility: hidden;
  width: 120px;
  background-color: #e97522;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  font-family: forma-djr-deck, sans-serif;
  letter-spacing: 1.5px;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  text-transform: uppercase;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  top: -30px;
  left: 50%;
  margin-left: -65px;
  line-height: normal;

  :after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-width: 5px;
    border-style: solid;
    border-color: #e97522 transparent transparent transparent;
    top: 100%;
    left: 50%;
    margin-left: -5px;
  }
`;

/* Link Styles */

const LinkWrapper = styled.a`
  text-decoration: none;
  color: inherit;
  border-bottom: 1px solid black;

  :hover {
    color: #e97522;
    border-color: #e97522;
  }
`;
